import {  useDispatch, useSelector } from "react-redux";
import { Droppable } from "react-beautiful-dnd";
import Project from "../projectComponent/Project";
import { useState, useEffect , useRef} from "react";
import { addTodoToFirebase } from "../../redux/actions/TodoManipulation/addTodoToFirebaseAction";
import AiModalComponent from "../aiModal/AiModalComponent";
import AiMessageModalComponent from "../aiMessageModal/AiMessageModal";
import { useIsMobile } from "../../functions/deviceIdentity/getDeviceType";

const OverviewComponent = ({
    zoomLevel,
    isProjectDragging,
    currentlyDraggedProjectId,
    projects
}) => {



    const aiAssistant = useSelector((state) => state.userSettings.aiAssistant);
    const [isHoverWand, setIsHoveredWand] = useState(false);
    const [showAiMessageModal, setShowAiMessageModal] = useState(false);
    const [newProjectAdded, setNewProjectAdded] = useState(false);
    const containerRef = useRef(null);
    const scrollToRight = () => {
        if (containerRef.current) {
            containerRef.current.scrollLeft = containerRef.current.scrollWidth;
        }
    };
    const handleMouseEnterWand = () => {
        setIsHoveredWand(true);
    };

    const handleLearnMore = () => {
        window.open('https://support.texthelp.com/help/smart-task-assistant', '_blank', 'noopener,noreferrer');
    }

   
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    const [projectTitle, setProjectTitle] = useState("");
    const [showAddProjectControls, setShowAddProjectControls] = useState(false);
    const [showAiModal, setShowAiModal] = useState(false);
    const [disableButtons, setDisableButtons] = useState(true);
    const handleAddProject = async (projectTitle) => {
        const json = {
            title: projectTitle,
            type: "1"
        };

        await dispatch(
            addTodoToFirebase(json)
        );
    };

    const openAiModal = () => {

        if (!projectTitle) return;

        if (aiAssistant) {
            setShowAiModal(true);
        } else {
            setShowAiMessageModal(true);
        }
    };
    const closeAiModal = () => {
        setShowAiModal(false);
        setDisableButtons(true);
        setProjectTitle("");
    };

    const closeAcceptAiMessageModal = () => {
        setShowAiMessageModal(false);

        setShowAiModal(true);
    };

    const closeRejectAiMessageModal = () => {
        setShowAiMessageModal(false);
    };

    const handleAddProjectChange = (event) => {
        if (event.key === 'Enter') {
            const title = event.target.value;
            if (title !== "") {
                handleAddProject(title);
                setProjectTitle("");
            }
        }
        else if (event.key === 'Escape') {
            setProjectTitle("");
        }
        else {
            if (event.key !== 'Enter') {
                setProjectTitle(event.target.value);

            }
        }

        if (event.target.value) {
            setDisableButtons(false);
        } else {
            setDisableButtons(true);
        }
    }

    useEffect(() => {
       
        if (newProjectAdded) {
            scrollToRight();
            setNewProjectAdded(false);
        }
    }, [projects]);

    return (
        <>
            <Droppable
                    droppableId="all-projects"
                    direction="horizontal"
                    type="project"
                    isCombineEnabled
                    
                >
                    {(provided) => (
                        <div
                            {...provided.droppableProps}
                           
                        className="gt-content__projects" style={{ fontSize: isMobile ? '10px' : `${zoomLevel}px` }} ref={(node) => {
                            provided.innerRef(node);
                            containerRef.current = node; // Use a callback ref to assign both refs
                        }}
                        >
                            {projects.map((project, index) => (
                                <Project
                                    key={project.$id}
                                    project={project}
                                    idx={index}
                                    zoomLevel={zoomLevel}
                                    isProjectDragging={isProjectDragging}
                                    currentlyDraggedProjectId={currentlyDraggedProjectId}
                                />
                            ))}
                        
                        {!showAddProjectControls ? (
                            <button
                                className="gt-content__add-section"
                                onClick={() => setShowAddProjectControls(prevState=>!prevState)}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg">
                                    <use xlinkHref="#globaltasks-svg-add"></use>
                                </svg>
                                Add new section
                            </button>
                        ) : (
                            <div className="gt-project" >
                                <div className="gt-project__header">
                                    <div className="gw-form-fieldset-item">
                                        <label
                                            className="gw-form-fieldset-item__label sr-only"
                                            htmlFor="new-section-title"
                                        >
                                            When
                                        </label>
                                        <input
                                            autoFocus={true}
                                            type="text"
                                            id="new-section-title"
                                            placeholder="My New Section..."
                                            className="gw-input"
                                            value={projectTitle}
                                            onChange={handleAddProjectChange}
                                            onKeyDown={handleAddProjectChange}
                                        />
                                    </div>
                                </div>

                                <div className="gw-group gw-group--align-right">
                                    <button className="gw-icon-button" aria-label="Help break this down"
                                        disabled={disableButtons}
                                        onClick={() => {
                                            openAiModal();
                                        }}
                                        onMouseEnter={handleMouseEnterWand}
                                    >
                                        <i className="gw-icon-button__icon gw-button__icon--ai"></i>
                                    </button>
                                    <button
                                        className="gw-button gw-button--s1"
                                        onClick={() => {
                                            setShowAddProjectControls(!showAddProjectControls);
                                            setDisableButtons(true);
                                            setProjectTitle("");
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        className="gw-button gw-button--s1 gw-button--primary"
                                        disabled={disableButtons}
                                        onClick={() => {
                                            if (projectTitle.trim() !== "") {
                                                handleAddProject(projectTitle);
                                                setNewProjectAdded(true);
                                                setProjectTitle("");
                                                setDisableButtons(true);
                                                setShowAddProjectControls(!showAddProjectControls);
                                            }
                                        }}
                                    >
                                        Save
                                    </button>
                                </div>

                                {/*{(isHoverWand && !aiAssistant) && (*/}
                                {/*    <div class="gw-infopopup gw-infopopup" style={{ width: "288px" }}>*/}
                                {/*        <div class="gw-infopopup__header">*/}
                                {/*            <h5>Help me break this down</h5>*/}
                                {/*        </div>*/}
                                {/*        <div class="gw-infopopup__body">*/}
                                {/*            <p>Click the magic wand and Global Tasks will break the task down into subtasks for you, like magic!</p>*/}
                                {/*        </div>*/}
                                {/*        <div class="gw-infopopup__footer gw-group gw-group--align-right">*/}
                                {/*            <button type="button" class="gw-button  gw-button--link"*/}
                                {/*                onClick={() => handleLearnMore()}*/}
                                {/*            >Learn more</button>*/}
                                {/*            <button type="button" class="gw-button  gw-button--link"*/}
                                {/*                onClick={() => setIsHoveredWand(false)}*/}
                                {/*            >Got it</button>*/}
                                {/*        </div>*/}
                                {/*    </div>)}*/}
                            </div>
                        )}
                        {provided.placeholder}
                        </div>
                    )}
            </Droppable>
            <AiModalComponent
                modalOpen={showAiModal}
                onClose={closeAiModal}
                todoTitle={projectTitle}
                newTodo={true}
            ></AiModalComponent>
            <AiMessageModalComponent
                modalOpen={showAiMessageModal}
                onCloseAccept={closeAcceptAiMessageModal}
                onCloseReject={closeRejectAiMessageModal}
            ></AiMessageModalComponent>
        </>

    );
};

export default OverviewComponent;
